// extracted by mini-css-extract-plugin
export default {"DeleteLibrariesDialog":"DeleteLibrariesDialog_DeleteLibrariesDialog__mdGMz"};